import coursesApi from '../../../../pages/catalog/assets/js/core/api';
import { createLogger, LogLevel } from '../../../../pages/catalog/assets/js/utils/logger';
import { renderCoursesModal } from '../ui/renderer';
import { initCoursesModalEvents } from '../ui/modal-events';
import { initCoursesModalSlider } from '../ui/slider';
import { teacherSlugToName } from './teacher-mapping';
import { getCourseLinkById } from '../../../../pages/catalog/assets/js/utils/course-by-id';

const logger = createLogger('CoursesModal', LogLevel.INFO);

export class CoursesModal {
  private teacherSlug: string;
  private teacherName: string;
  private grade?: string;
  private courses: any[] = [];

  constructor(teacherSlug: string, grade?: string) {
    logger.info('Конструктор CoursesModal, teacherSlug:', teacherSlug, 'grade:', grade);
    this.teacherSlug = teacherSlug;
    this.teacherName = teacherSlugToName[teacherSlug] || '';
    this.grade = grade;
    if (!this.teacherName) {
      logger.warn('Не найдено имя преподавателя для slug:', teacherSlug);
    }
  }

  public async init(): Promise<void> {
    logger.info('Старт init модалки для преподавателя:', this.teacherSlug, '(', this.teacherName, ')', 'grade:', this.grade);
    await this.loadCourses();

    // Если только 1 курс — редиректим на его страницу
    if (this.courses.length === 1) {
      const courseId = this.courses[0].id;
      const permalink = getCourseLinkById(courseId);
      if (permalink) {
        logger.info('Один курс, редиректим на:', permalink);
        window.location.href = permalink;
        return; 
      } else {
        logger.warn('Permalink для курса не найден, показываем модалку');
      }
    }

    logger.info('Завершение init модалки для преподавателя:', this.teacherSlug);
    this.render();
  }

  private async loadCourses(): Promise<void> {
    try {
      logger.info('Старт загрузки курсов для преподавателя:', this.teacherName, 'с фильтром grade:', this.grade);
      
      // Подготавливаем параметры для API запроса
      const apiParams: any = { teacher: this.teacherName };
      
      // Определяем тип фильтра по grade
      if (this.grade) {
        // Если grade - число или содержит "класс", это фильтр по классу
        const isNumericOrClass = /^\d+$/.test(this.grade) || this.grade.includes('класс');
        
        if (isNumericOrClass) {
          // Извлекаем число из строки (например, "10 класс" -> "10")
          const classNumber = this.grade.match(/\d+/)?.[0];
          if (classNumber) {
            apiParams.class = parseInt(classNumber);
            logger.info('Добавлен фильтр по классу:', apiParams.class);
          }
        } else {
          // Иначе это фильтр по цели (ЕГЭ, ОГЭ и т.д.)
          // Преобразуем в нижний регистр для API
          apiParams.goal = this.grade.toLowerCase();
          logger.info('Добавлен фильтр по цели:', apiParams.goal);
        }
      }
      
      const response = await coursesApi.getCourses(apiParams);
      this.courses = response.data;
      logger.info(`Загружено курсов: ${this.courses.length} с параметрами:`, apiParams);
      if (!this.courses.length) {
        logger.warn('Для преподавателя не найдено курсов!');
      }
      logger.info('Завершение загрузки курсов для преподавателя:', this.teacherName);
    } catch (error) {
      logger.error('Ошибка при загрузке курсов:', error);
    }
  }

  private render(): void {
    logger.info('Рендерим модалку курсов для преподавателя:', this.teacherSlug, '(', this.teacherName, ')');

    const modalWrapper = document.createElement('div');
    modalWrapper.className = 'modal open course-modal';
    document.body.appendChild(modalWrapper);

    const modalContent = document.createElement('div');
    modalContent.className = 'modal__content';
    modalWrapper.appendChild(modalContent);

    const renderedModal = renderCoursesModal(this.courses, this.courses[0]?.teacher || this.teacherName || '');
    if (renderedModal) {
      modalContent.appendChild(renderedModal);
    }

    initCoursesModalEvents(modalWrapper);
    initCoursesModalSlider(modalWrapper);
  }
} 